import type { ResourceProps } from 'react-admin';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import { DashboardResources } from '@src/types';

import ShopifyRedirectsList from './ShopifyRedirectsList';
import ShopifyRedirectsShow from './ShopifyRedirectsShow';

export { shopifyRedirectsDataProvider } from './dataProvider';
export type { ShopifyProductRedirect } from './types';

const resource: ResourceProps = {
  name: DashboardResources.ShopifyRedirects,
  list: ShopifyRedirectsList,
  show: ShopifyRedirectsShow,
  icon: AltRouteIcon,
  options: { label: 'Shopify Redirects' },
};

export default resource;
